// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import AsyncComputed from 'vue-async-computed';
import Vue2Crumbs from 'vue-2-crumbs';
import Fragment from 'vue-fragment';

// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import store from './store';


import App from './App';
import router from './router';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(AsyncComputed);
Vue.use(Vue2Crumbs);
Vue.use(Fragment.Plugin);

// contextual properties
Vue.prototype.$devProxy = '/api/exist/rest/db/portal-corte-costituzionale/';
// Vue.prototype.$prodProxy = 'http://bach.cirsfid.unibo.it:8081/exist/rest/db/portal-corte-costituzionale/';
Vue.prototype.$prodProxy = '/node/exist-proxy/?exist=8081&path=portal-corte-costituzionale/';
Vue.prototype.$proxy =
  (process.env.NODE_ENV === 'development') ?
    Vue.prototype.$devProxy :
    Vue.prototype.$prodProxy;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js